Object.defineProperty(exports, "__esModule", { value: true });
const language_service_1 = require("@volar/language-service");
const vue = require("@volar/vue-language-core");
const plugin = (context) => {
    if (!context.typescript)
        return {};
    const _ts = context.typescript;
    return {
        inlayHints: {
            on(document, range) {
                return worker(document.uri, (vueFile) => {
                    const hoverOffsets = [];
                    const inlayHints = [];
                    for (const pointer of document.getText(range).matchAll(/<!--\s*\^\?\s*-->/g)) {
                        const offset = pointer.index + pointer[0].indexOf('^?') + document.offsetAt(range.start);
                        const position = document.positionAt(offset);
                        hoverOffsets.push([position, document.offsetAt({
                                line: position.line - 1,
                                character: position.character,
                            })]);
                    }
                    (0, language_service_1.forEachEmbeddedFile)(vueFile, (embedded) => {
                        if (embedded.kind === language_service_1.FileKind.TypeScriptHostFile) {
                            for (const [_, map] of context.documents.getMapsByVirtualFileUri(document.uri)) {
                                for (const [pointerPosition, hoverOffset] of hoverOffsets) {
                                    for (const [tsOffset, mapping] of map.map.toGeneratedOffsets(hoverOffset)) {
                                        if (mapping.data.hover) {
                                            const quickInfo = _ts.languageService.getQuickInfoAtPosition(embedded.fileName, tsOffset);
                                            if (quickInfo) {
                                                inlayHints.push({
                                                    position: { line: pointerPosition.line, character: pointerPosition.character + 2 },
                                                    label: _ts.module.displayPartsToString(quickInfo.displayParts),
                                                    paddingLeft: true,
                                                    paddingRight: false,
                                                });
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    });
                    return inlayHints;
                });
            },
        },
    };
    function worker(uri, callback) {
        const [virtualFile] = context.documents.getVirtualFileByUri(uri);
        if (!(virtualFile instanceof vue.VueFile))
            return;
        return callback(virtualFile);
    }
};
exports.default = () => plugin;
//# sourceMappingURL=vue-twoslash-queries.js.map